import { installFragment } from './fragment'
import { installResizeText } from './resize-text'
import { installTooltip } from './tooltip'
import { installVue2InstanceCompat } from './vue2-instance-compat'

export function installAppPlugins(app) {
  installVue2InstanceCompat(app)
  installResizeText(app)
  installFragment(app)
  installTooltip(app)
}
